import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {AuthEnum} from '@/store/auth/auth.enum';
import {
  EntityMember,
  Member, MemberInitState, PersonEmergencies,
} from '@/store/member/member.types';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';
import BgThemePublic from '@/components/bg-theme-public.vue';
import 'vue-select/dist/vue-select.css';
import {LoginInfo} from '@/store/auth/auth.types';
import AddressCurrentComponent from '@/components/register/AddressCurrent.vue';
import AddressEmergenciesComponent from '@/components/register/AddressEmergencies.vue';
import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';
import {ResponseCode} from '@/class/http';
import UploadProfileComponent from '@/components/upload/UploadProfile.vue';


@Component({
  components: {
    UploadProfileComponent,
    AddressCurrentComponent,
    AddressEmergenciesComponent,
    BgThemePublic
  }
})
export default class EditProfileComponent extends Vue {

  @State('member') memberState!: MemberInitState;
  @State('address') addressInitState!: AddressInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_getCheckMobilePhone', {namespace: 'member'}) getCheckMobilePhone!: (payload: string) => Promise<number>;
  @Action('_getMemberById', {namespace: 'member'}) getMemberById!: (payload: string) => Promise<void>;
  @Action('_updateMember', {namespace: 'member'}) updateMember!: (payload: Member) => Promise<void>;
  @Action('_getProvinces', {namespace: 'address'}) getProvinces!: () => Promise<void>;
  @Action('_getAmphures', {namespace: 'address'}) getAmphures!: (payload: string) => Promise<void>;
  @Action('_getDistricts', {namespace: 'address'}) getDistricts!: (payload: string) => Promise<void>;


  public provinces = [{id: 0}] as Provinces[];
  public amphures = [{id: 0}] as Amphures[];
  public districts = [{id: 0}] as Districts[];
  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;


  public showpassword = true;
  public isReady = false;
  public title = [
    {value: 'นาย'},
    {value: 'นาง'},
    {value: 'นางสาว'},
    {value: 'ด.ช.'},
    {value: 'ด.ญ.'},
    {value: 'อื่นๆ'}
  ];
  public gender = [
    {text: 'ชาย', value: 'male'},
    {text: 'หญิง', value: 'female'}
  ];
  public MemberData = {
    branch: {},
    community: {},
    bondsman: {},
    personEmergencies: [{}]
  } as EntityMember;


  async mounted() {
    await this.Loading(true);
    await this.getMemberById(this.loginInfo.id);
    this.MemberData = await this.memberState.profile
    if (this.MemberData.personEmergencies.length === 0) {
      this.MemberData.personEmergencies.push({
        firstName: '',
        lastName: '',
        mobilePhone: '',
        memberId: this.MemberData.id
      } as PersonEmergencies)
    }
    // @ts-ignore
    this.MemberData.password = null
    await this.getProvinces();
    this.provinces = this.addressInitState.provinces;
    if (this.MemberData.currentProvinces !== '') {
      await this.getAmphures(this.MemberData.currentProvinces);
      this.amphures = this.addressInitState.amphures;
    }
    if (this.MemberData.currentAmphures !== '') {
      await this.getDistricts(this.MemberData.currentAmphures);
      this.districts = this.addressInitState.districts;
    }
    this.isReady = true;
    await this.Loading(false);
    console.log(this.MemberData)
  }

  async CheckMobilePhone(e: { target: { value: string } }) {
    if (e.target.value.match(/^[0-9]+$/) !== null) {
      await this.getCheckMobilePhone(e.target.value);
      let CheckMobile = this.memberState.checkMobile;
      if (CheckMobile === 0) {
        this.MemberData.mobilePhone = e.target.value;
      } else {
        this.Toast({
          heading: 'หมายเลขโทรศัพท์นี้มีการลงทะเบียนไว้แล้ว',
          message: 'กรุณากรอกหมายเลขโทรศัพท์อีกครั้ง',
          type: 'danger'
        }).then();
        this.MemberData.mobilePhone = '';
      }
    } else {
      this.Toast({
        heading: 'กรุณากรอกข้อมูลใหม่',
        message: 'กรุณากรอกหมายเลขโทรศัพท์อีกครั้ง',
        type: 'danger'
      }).then();
      this.MemberData.mobilePhone = '';
    }
  }

  async ChangePassword(e: { target: { value: string } }) {
    console.log('DEBUG: ChangePassword', this.MemberData.password);
    if (this.MemberData.password.match(/^[0-9]+$/) !== null) {
    } else {
      this.Toast({
        heading: 'กรุณากรอกรหัสผ่านใหม่',
        message: 'กรุณากรอกรหัสผ่านตัวเลข 6 หลัก',
        type: 'danger'
      }).then();
      // @ts-ignore
      this.MemberData.password = null;
    }
  }


  async stepOne() {
    let forms = document.getElementsByClassName('step-one');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }


    delete this.MemberData.createdBy;
    delete this.MemberData.modifiedBy;
    delete this.MemberData.deletedBy;
    delete this.MemberData.createdAt;
    delete this.MemberData.modifiedAt;
    delete this.MemberData.deletedAt;
    delete this.MemberData.personEmergencies[0].createdBy;
    delete this.MemberData.personEmergencies[0].modifiedBy;
    delete this.MemberData.personEmergencies[0].deletedBy;
    delete this.MemberData.personEmergencies[0].createdAt;
    delete this.MemberData.personEmergencies[0].modifiedAt;
    delete this.MemberData.personEmergencies[0].deletedAt;
    // @ts-ignore
    delete this.MemberData.community;
    // @ts-ignore
    delete this.MemberData.bondsman;
    // @ts-ignore
    delete this.MemberData.branch;

    await this.Loading(true)

    let resMember = await this.updateMember(this.MemberData)
    let stats = JSON.parse(JSON.stringify(resMember)).data as ResponseCode;
    if (stats.appCode === 20002) {
      await this.Toast({
        message: 'แก้ข้อมูลส่วนตัวเรียบร้อยแล้ว',
        heading: 'บันทึกข้อมูลสำเร็จ',
        type: 'success',
      });
      await this.getMemberById(this.loginInfo.id);
      this.$router.push('/profile').then();
      await this.Loading(false)
    } else {
      await this.Toast({
        message: 'กรุณาลองใหม่อีกครั้ง',
        heading: 'แก้ข้อมูลส่วนตัวไม่สำเร็จ',
        type: 'warning',
      });
      await this.Loading(false)
    }
  }


  async selProvinces() {
    if (this.MemberData.currentProvinces) {
      await this.getAmphures(this.MemberData.currentProvinces);
      this.MemberData.currentAmphures = '';
      this.amphures = this.addressInitState.amphures;

    }
  }

  async selAmphures() {
    if (this.MemberData.currentAmphures) {
      await this.getDistricts(this.MemberData.currentAmphures);
      this.MemberData.currentDistricts = '';
      this.districts = this.addressInitState.districts;
    }
  }

  async selDistricts() {
    let district = this.districts.find((x) => x.id === Number(this.MemberData.currentDistricts));
    if (district) {
      this.MemberData.currentZip = district.zipCode;
    }
  }

  actionSetProfile(refId: string) {
    this.MemberData.profile = refId;
  }
}
